module.exports = __webpack_public_path__ + "static/media/naturitalia-512.8a980127.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/naturitalia-512.png
// module id = 776
// module chunks = 0